import type { FaireProductEntity } from "../../entity_types/product";

export const p_40l7femjgj: FaireProductEntity = {
  token: "p_40l7femjgj",
  type: "product",
  name: "Mr. & Mrs Lg Charm Bowl (Boxed)",
  brandToken: "b_4ff718f6",
  brandName: "Basic Spirit",
  imageUrl:
    "https://cdn.faire.com/fastly/a7d67bea698568d31705d7e91a8f6c83d36984e92a732b9c7fd6aa2ff28d0e03.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5ec55da4e1b208c622bd3f04d0d1f716f0e9b203f429617f6a36a0d22e1540e0.jpeg",
  ],
  priceDollars: 11.64,
  description:
    'The Mr & Mrs Heart Dish is a beautifully crafted pewter charm bowl, perfect for celebrating love and unity. This elegantly designed dish features a heart shape, symbolizing the bond between partners, making it an ideal gift for weddings, anniversaries, or special occasions. Each bowl is thoughtfully packaged in a stylish box, ensuring it is ready for gifting or display.\nApprox piece 2.25" in diameter.\nComes in a gift box w/ pewter decorative piece Approx 3" x 3" x .75".\nHandmade By The Sea!\n10% Of profits fund charitable organizations. ',
  tags: [],
  msrpDollars: 23.29,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:22:35.654Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
